module.exports = __webpack_public_path__ + "static/media/now-mockup.894bee3b.jpg";